export default {
  share: {
    // General
    root: 'Home',
    items: 'items',
    folder_count: '{count} folder | {count} folders',
    file_count: '{count} file | {count} files',
    and: 'and',
    empty_folder: 'This folder is empty',
    empty_folder_subtitle: 'No files have been shared in this folder yet.',
    download: 'Download',
    download_item: 'Download {name}',
    playlist: 'Playlist',
    now_playing: 'Now playing',
    playing_item: 'Playing {current} of {total}',
    track_count: '{count} track | {count} tracks',
    video_count: '{count} video | {count} videos',
    image_count: '{count} image | {count} images',
    document_count: '{count} document | {count} documents',
    show_more: 'Show more',
    show_less: 'Show less',
    close: 'Close',

    // Password
    password_required: 'Password required',
    password_required_message: 'This share is protected by a password. Please enter the password to access the content.',
    password: 'Password',
    access: 'Access',
    invalid_password: 'Invalid password. Please try again.',
    show_password: 'Show password',
    hide_password: 'Hide password',

    // Errors
    expired_title: 'Share unavailable',
    expired_default: 'This share is no longer available.',
    expired_message: 'This share has expired.',
    not_found: 'This share does not exist or has been deleted.',
    view_limit_reached: 'This share has reached its view limit.',
    page_not_found: 'Page not found',
    page_not_found_message: 'The page you are looking for does not exist.',

    // Asset viewer
    document_preview_unavailable: 'Preview not available for this file type.',

    // Linked files
    linked_files: 'Linked files',

    // Auth CTA
    login: 'Log in',
    register: 'Sign up free',

    // Attribution
    powered_by: 'Shared with',
    powered_by_cta: 'Create yours',
  },
}
